const IS_REDUCED_MOTION = window.matchMedia("(prefers-reduced-motion: reduce)").matches
const ELEMENTS = 'cursor-hover'

const DEFAULT_CLASS = 'cursor-active'

class Cursor {
  constructor() {
    if (window.matchMedia('(pointer: coarse)').matches) return

    if(IS_REDUCED_MOTION) {
      document.body.classList.add('reduced-motion')
      return false
    }

    document.querySelectorAll('.cursor-hover').forEach(el => {
      const parent = el.closest('.works__item')
      const cursor = parent.querySelector('.cursor')

      el.addEventListener('mousemove', (e) => {
        this.resetClass(parent)

        if(!parent.classList.contains(DEFAULT_CLASS)){
          parent.classList.add(DEFAULT_CLASS)
        }

        const left = e.clientX - el.getBoundingClientRect().left
        const top = e.clientY - el.getBoundingClientRect().top

        cursor.style.transform = `translate3d(${left}px,${top}px, 0)`
      });
    })
  }

  resetClass = (current) => {
      document.querySelectorAll('.works__item').forEach(el => {
        if(el != current){
          el.classList.remove(DEFAULT_CLASS)
        }
    })
  }
}

new Cursor();
